// import generateJoke from "./aadv";
import "./styles/main.scss";

// Import all of Bootstrap's JS
import * as bootstrap from "bootstrap";
import axios from "axios";
import moment from "moment";

//this will load everything in assets folder
require.context("./assets/", true, /^\.\/.*\.*/);
const programsArr = [
  {
    programName: "Diplomas",
    accordionNarr: "Diplomas",
  },
  {
    programName: "Foundation Studies",
    accordionNarr: "Foundation Studies",
  },
  {
    programName: "Pre-Masters",
    accordionNarr: "Pre-Masters",
  },
  {
    programName: "Foundation English Entry Course (FEEC)",
    accordionNarr: "Foundation English Entry Course (FEEC)",
  },
  {
    programName: "University English Entry Course (UEEC)",
    accordionNarr: "University English Entry Course (UEEC)",
  },
  {
    programName: "Online University English Entry Course (OUEEC)",
    accordionNarr: "Online University English Entry Course (OUEEC)",
  },
  {
    programName: "Tertiary Orientation Program (TOP) (5 weeks)",
    accordionNarr: "Tertiary Orientation Program (TOP) (5 weeks)",
  },
];

const countryArr = [
  "Afghanistan",
  "Aland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo, The Democratic Republic",
  "Cook Islands",
  "Costa Rica",
  "Cote D'Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "England",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "Fmr Yugoslav Rep of Macedonia",
  "France",
  "French Guiana",
  "French Polynesia",
  "Former Yugoslav Republic of Macedonia (FYROM)",
  "Gabon",
  "Gambia",
  "Gaza Strip and West Bank",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Holy See (Vatican City State)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran (Islamic Republic Of)",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kenya",
  "Kiribati",
  "Korea, Democratic People's Republic of (North)",
  "Korea, Republic of",
  "Kosovo",
  "Kuwait",
  "Kyrgyz Republic",
  "Lao People's Democratic Rep",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libyan Arab Jamahiriya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia, Federated States of",
  "Moldova, Republic of",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Ireland",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine Territory",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Republic of Serbia",
  "Reunion",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Saint Barthelemy",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Pierre and Miquelon",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Scotland",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "St Vincent and the Grenadines",
  "Sudan",
  "Suriname",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Viet Nam",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Wales",
  "Wallis and Futuna Islands",
  "Western Sahara",
  "Yemen",
  "Yugoslavia",
  "Zambia",
  "Zimbabwe",
];

function makeid(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}
//LOAD KEY DATES
let feecProgArr = [];
let ueecProgArr = [];

let keyDates = [];
let noCache = makeid(5);
axios
  .get("assets/unswg_KeyDates_aem.csv?v=" + noCache)
  .then(function (response) {
    keyDates = CSVToArray(response.data);

    // remove header row if present
    const rows = keyDates.slice(1);

    feecProgArr = [
      ...new Set(
        rows
          .filter(row => row[0] === "Foundation English Entry Course (FEEC)")
          .map(row => row[2])
          .filter(Boolean)
      )
    ];

    ueecProgArr = [
      ...new Set(
        rows
          .filter(row => row[0] === "University English Entry Course (UEEC)")
          .map(row => row[2])
          .filter(Boolean)
      )
    ];

    console.log("FEEC:", feecProgArr);
    console.log("UEEC:", ueecProgArr);
  })
  .catch(function (error) {
    console.log(error);
  });
function watchAccordion() {
  // var aadvPlusMinusArry = document.getElementsByClassName("aadvcircle-plus");
  var aadvAccordionArry = document.getElementsByClassName(
    "aadvProgramBoxOption"
  );
  var aadvTableWrapArry = document.getElementsByClassName("aadvTableWrap");

  for (var i = 0; i < aadvAccordionArry.length; i++) {
    aadvAccordionArry[i].addEventListener(
      "click",
      function () {
        // console.log(this);
        this.classList.toggle("aadvopened");
        let thisProg = this.getAttribute("data-prog");
        // console.log("looking for " + thisProg);

        for (var ii = 0; ii < aadvTableWrapArry.length; ii++) {
          if (aadvTableWrapArry[ii].classList.contains("active")) {
            aadvTableWrapArry[ii].classList.remove("active");
          }
        }

        let blnOnOff = this.classList.contains("aadvopened") ? true : false;
        //is it on or off?
        if (blnOnOff) {
          document.getElementById(thisProg + "-wrap").classList.add("active");
        } else {
          document
            .getElementById(thisProg + "-wrap")
            .classList.remove("active");
        }

        for (var ii = 0; ii < aadvAccordionArry.length; ii++) {
          if (
            aadvAccordionArry[ii].classList.contains("aadvopened") &&
            !aadvAccordionArry[ii].classList.contains("progbox" + thisProg)
          ) {
            aadvAccordionArry[ii].classList.remove("aadvopened");
          }
        }
      },
      false
    );
  }
}

function CSVToArray(strData, strDelimiter) {
  // Check to see if the delimiter is defined. If not,
  // then default to comma.
  strDelimiter = strDelimiter || ",";

  // Create a regular expression to parse the CSV values.
  var objPattern = new RegExp(
    // Delimiters.
    "(\\" +
      strDelimiter +
      "|\\r?\\n|\\r|^)" +
      // Quoted fields.
      '(?:"([^"]*(?:""[^"]*)*)"|' +
      // Standard fields.
      '([^"\\' +
      strDelimiter +
      "\\r\\n]*))",
    "gi"
  );

  // Create an array to hold our data. Give the array
  // a default empty first row.
  var arrData = [[]];

  // Create an array to hold our individual pattern
  // matching groups.
  var arrMatches = null;

  // Keep looping over the regular expression matches
  // until we can no longer find a match.
  while ((arrMatches = objPattern.exec(strData))) {
    // Get the delimiter that was found.
    var strMatchedDelimiter = arrMatches[1];

    // Check to see if the given delimiter has a length
    // (is not the start of string) and if it matches
    // field delimiter. If id does not, then we know
    // that this delimiter is a row delimiter.
    if (strMatchedDelimiter.length && strMatchedDelimiter != strDelimiter) {
      // Since we have reached a new row of data,
      // add an empty row to our data array.
      arrData.push([]);
    }

    // Now that we have our delimiter out of the way,
    // let's check to see which kind of value we
    // captured (quoted or unquoted).
    if (arrMatches[2]) {
      // We found a quoted value. When we capture
      // this value, unescape any double quotes.
      var strMatchedValue = arrMatches[2].replace(new RegExp('""', "g"), '"');
    } else {
      // We found a non-quoted value.
      var strMatchedValue = arrMatches[3];
    }

    // Now that we have our value string, let's add
    // it to the data array.
    arrData[arrData.length - 1].push(strMatchedValue);
  }

  // Return the parsed data.
  return arrData;
}


// Executes after DOM is loaded (before images and CSS):
document.addEventListener("DOMContentLoaded", function () {
  const aadvProgramBox = document.getElementById("aadvProgramBox");

  const aadvProgramBoxOptions = document.getElementById(
    "aadvProgramBoxOptions"
  );


  //populate country select list
  let aadvCountry = document.getElementById("aadvCountry");
  var el = document.createElement("option");
  el.textContent = "[SELECT]";
  el.value = "";
  aadvCountry.appendChild(el);

  for (var i = 0; i < countryArr.length; i++) {
    var opt = countryArr[i];
    var el = document.createElement("option");
    el.textContent = opt;
    el.value = opt;
    aadvCountry.appendChild(el);
  }

  aadvCountry.addEventListener("change", function () {
    if (aadvCountry.value == "") {
      aadvProgramBox.classList.remove("active");
    } else {
      aadvProgramBox.classList.add("active");
      outputStep();
    }
  });

  

  //****************//
  //RETURN DEADLINES//
  //****************//
  const returnDeadlines = (
    auBln,
    orientationdate,
    startdate,
    progName
  ) => {
    let lastDayOffset = 0;
    let lastDayAcceptOfferOffset = 0;

    //RETURNS array where
    // [0] = Last day to apply
    // [1] = Last day to Accept your offer

    //get Orientation Date
    let orientationdateArr = orientationdate.split("-");
    if (orientationdateArr[2].length == 2) {
      orientationdateArr[2] = "20" + orientationdateArr[2];
    }

    orientationdate =
      orientationdateArr[0] +
      "-" +
      orientationdateArr[1] +
      "-" +
      orientationdateArr[2];

    let d = new Date(orientationdate);
    let startdateArr = startdate.split("-");
    startdate = startdateArr[0] + "-" + startdateArr[1] + "-20" + startdateArr[2];
    let sd = new Date(startdate);
    //shift to the Monday
    d = moment(d).startOf("isoweek");

    let cutoffNewRules = new Date('2027-01-01');

    if (d > cutoffNewRules) {
      //NEW RULES FOR 2027 +
      lastDayOffset = 8 * 7; //Monday 8 weeks before
      lastDayAcceptOfferOffset =  5 * 7; //Monday 5 weeks before
      
    } else {
        lastDayOffset = 8 * 7;
        lastDayAcceptOfferOffset = 5 * 7;
    }
   

    if (auBln) {
       if (d > cutoffNewRules) {
          //NEW RULES FOR 2027 +
          var m = moment(sd); //start date
          
              let fridayBefore = moment(sd).day(5);
              if (fridayBefore.isSameOrAfter(m, 'day')) {
                fridayBefore.subtract(7, 'days');
              }
              let tuesdayAfter = moment(sd).day(2);
              if (tuesdayAfter.isSameOrBefore(m, 'day')) {
                tuesdayAfter.add(7, 'days');
              }
              let ldod = moment(fridayBefore).format("DD-MMM-YY");
              let ldad = moment(tuesdayAfter).format("DD-MMM-YY");
              let retDateArr = [ldod, ldad];
              return retDateArr;
         
          
       } else {

          let ldod = moment(sd).day(-2).format("DD-MMM-YY"); //previous Friday
          let ldad = moment(sd).add(1, "days").format("DD-MMM-YY"); //add one day to start date get Tuesday
          let retDateArr = [ldod, ldad];
          if (progName == "Diplomas" && orientationdate == "15-Jan-2026") {
            retDateArr = ["5-Jan-26", "12-Jan-26"];
            // console.log("BBB",retDateArr);
          }
          if (progName == "Diplomas" && orientationdate == "7-May-2026") {
            retDateArr = ["27-Apr-26", "4-May-26"];
            // console.log("DDD",retDateArr);
          }
          if (progName == "Diplomas" && orientationdate == "27-Aug-2026") {
            retDateArr = ["17-Aug-26", "24-Aug-26"];
            // console.log("FFF",retDateArr);
          }
          // console.log("progName:" + progName + " OD:" + orientationdate);
          if (progName == "Foundation Studies" && orientationdate == "12-Nov-2025") {
            retDateArr = ["27-Jul-25", "18-Nov-25"];
            // console.log("FFF",retDateArr);
          }
          return retDateArr;
        }
    }
    if (progName == "Online University English Entry Course (OUEEC)") {
      if (d > cutoffNewRules) {
        //NEW RULES FOR 2027 +
        var m = moment(sd); //start date
      
        let wednesdayWeekBefore = m.clone()
        .subtract(1, 'week')
        .isoWeekday(3); // 3 = Wednesday

        let fridayBefore = m.clone().isoWeekday(5); // 5 = Friday

        if (fridayBefore.isSameOrAfter(m, 'day')) {
          fridayBefore.subtract(1, 'week');
        }

        let ldod = moment(wednesdayWeekBefore).format("DD-MMM-YY");
        let ldad = moment(fridayBefore).format("DD-MMM-YY");
        let retDateArr = [ldod, ldad];
        return retDateArr;
      } else {
        //2026 RULES
        var m = moment(sd); //start date
      
        // let wednesdayWeekBefore = m.clone()
        // .subtract(1, 'week')
        // .isoWeekday(3); // 3 = Wednesday

        let fridayBefore = m.clone().isoWeekday(5); // 5 = Friday

        if (fridayBefore.isSameOrAfter(m, 'day')) {
          fridayBefore.subtract(1, 'week');
        }

        let ldod = moment(fridayBefore).format("DD-MMM-YY");
        let ldad = moment(sd).format("DD-MMM-YY");
        let retDateArr = [ldod, ldad];
        return retDateArr;
      }
    }
    let ldod = moment(d).subtract({ days: lastDayOffset }).format("DD-MMM-YY");
    let ldad = moment(d)
      .subtract({ days: lastDayAcceptOfferOffset })
      .format("DD-MMM-YY");
    let retDateArr = [ldod, ldad];
    // console.log(progName, orientationdate, auBln);

   
    if (progName == "Diplomas" && orientationdate == "7-May-2026" && auBln == false) {
      retDateArr = ["5-Mar-26",  "13-Mar-26"];
      // console.log("CCC",retDateArr);
    }
    if (progName == "Diplomas" && orientationdate == "27-Aug-2026" && auBln == false) {
      retDateArr = ["25-Jun-26", "3-Jul-26"];
      // console.log("EEE",retDateArr);
    }
    
    // if (progName == "Pre-Masters" && orientationdate == "7-May-2026" && auBln == false) {
    //   retDateArr = ["9-Mar-26", "2-Apr-26"];
    // }
    // if (progName == "Pre-Masters" && orientationdate == "27-Aug-2026" && auBln == false) {
    //   retDateArr = ["29-Jun-26", "23-Jul-26"];
    // }
    // console.log("retDateArr");
    // console.log(retDateArr);
    return retDateArr;
  };

  const getProgDates = (progName) => {
    // let feecProgArr = ["Standard Foundation Program", "Standard Plus Foundation Program", "Transition Program"];
    // let ueecProgArr = ["Diplomas", "Degree", "Pre-Masters"];
    let foundationProgArr = [
      "Standard Foundation Program",
      "Standard Plus Foundation Program",
      "Transition Program",
    ];
    let progNameCode = progName.replace(/[^0-9a-z]/gi, "");

    let auBln = aadvCountry.value == "Australia" ? true : false;
    let dateArr = [];
    let englishProgramBln = 0;
    let program = "";
    let orientationdate = "";
    let startdate = "";
    let weekone = "";
    let returnHTML = "";
    let returnHTMLtable =
      '<div class="aadvTableWrap" id="' + progNameCode + '-wrap">';

    if (progName == "Foundation English Entry Course (FEEC)") {
      returnHTMLtable += '<div class="filterfeecflex">';
      returnHTMLtable += '  <div class="filterbox">';
      returnHTMLtable += "  <label for='feecentryto'>For Entry to</label>";
      returnHTMLtable +=
        '    <select class="form-select" aria-label="Select the program you are entering" id="feecentryto">';
      returnHTMLtable += '      <option value="">[SELECT]</option>';
      for (let ii = 0; ii < feecProgArr.length; ii++) {
        returnHTMLtable +=
          '  <option value="' +
          feecProgArr[ii].replace(/[^0-9a-z]/gi, "") +
          '">' +
          feecProgArr[ii] +
          "</option>";
      }
      returnHTMLtable += "    </select>";
      returnHTMLtable += "  </div>";

      returnHTMLtable += '  <div class="filterbox">';
      returnHTMLtable += "  <label for='feecduration'>Select Duration</label>";
      returnHTMLtable +=
        '    <select class="form-select" aria-label="Select your program duration" id="feecduration">';
      returnHTMLtable += '      <option value="">[SELECT]</option>';
      returnHTMLtable += '      <option value="10Weeks">10 Weeks</option>';
      returnHTMLtable += '      <option value="20Weeks">20 Weeks</option>';
      returnHTMLtable += "    </select>";
      returnHTMLtable += "  </div>";
      returnHTMLtable += "</div>";
      returnHTMLtable += "<div id='feectablewrap' style='display:none;'>";
    }

    if (progName == "University English Entry Course (UEEC)") {
      returnHTMLtable += '<div class="filterfeecflex">';
      returnHTMLtable += '  <div class="filterbox">';
      returnHTMLtable += '  <label for="ueecentryto">For Entry to</label>';
      returnHTMLtable +=
        '    <select class="form-select" aria-label="Select the program you are entering" id="ueecentryto">';
      returnHTMLtable += '      <option value="">[SELECT]</option>';
      for (let ii = 0; ii < ueecProgArr.length; ii++) {
        returnHTMLtable +=
          '  <option value="' +
          ueecProgArr[ii].replace(/[^0-9a-z]/gi, "") +
          '">' +
          ueecProgArr[ii] +
          "</option>";
      }
      returnHTMLtable += "    </select>";
      returnHTMLtable += "  </div>";

      returnHTMLtable += '  <div class="filterbox">';
      returnHTMLtable += '  <label for="ueecduration">Select Duration</label>';
      returnHTMLtable +=
        '    <select class="form-select" aria-label="Select your program duration" id="ueecduration">';
      returnHTMLtable += '      <option value="">[SELECT]</option>';
      returnHTMLtable += '      <option value="10Weeks">10 Weeks</option>';
      returnHTMLtable += '      <option value="15Weeks">15 Weeks</option>';
      returnHTMLtable += '      <option value="20Weeks">20 Weeks</option>';
      returnHTMLtable += '      <option value="30Weeks">30 Weeks</option>';
      returnHTMLtable += "    </select>";
      returnHTMLtable += "  </div>";
      returnHTMLtable += "</div>";
      returnHTMLtable += "<div id='ueectablewrap' style='display:none;'>";
    }
    // if (progName == "Online University English Entry Course (OUEEC)") {
    //   returnHTMLtable += '<div class="filterfeecflex">';
    //   returnHTMLtable += '  <div class="filterbox">';
    //   returnHTMLtable += '  <label for="oueecentryto">For Entry to</label>';
    //   returnHTMLtable +=
    //     '    <select class="form-select" aria-label="Select the program you are entering" id="oueecentryto">';
    //   returnHTMLtable += '      <option value="">[SELECT]</option>';
    //   for (let ii = 0; ii < oueecProgArr.length; ii++) {
    //     returnHTMLtable +=
    //       '  <option value="' +
    //       oueecProgArr[ii].replace(/[^0-9a-z]/gi, "") +
    //       '">' +
    //       oueecProgArr[ii] +
    //       "</option>";
    //   }
    //   returnHTMLtable += "    </select>";
    //   returnHTMLtable += "  </div>";

    //   returnHTMLtable += '  <div class="filterbox">';
    //   returnHTMLtable += '  <label for="oueecduration">Select Duration</label>';
    //   returnHTMLtable +=
    //     '    <select class="form-select" aria-label="Select your program duration" id="oueecduration">';
    //   returnHTMLtable += '      <option value="">[SELECT]</option>';
    //   returnHTMLtable += '      <option value="10Weeks">10 Weeks</option>';
    //   returnHTMLtable += '      <option value="15Weeks">15 Weeks</option>';
    //   returnHTMLtable += '      <option value="20Weeks">20 Weeks</option>';
    //   returnHTMLtable += '      <option value="30Weeks">30 Weeks</option>';
    //   returnHTMLtable += "    </select>";
    //   returnHTMLtable += "  </div>";
    //   returnHTMLtable += "</div>";
    //   returnHTMLtable += "<div id='oueectablewrap' style='display:none;'>";
    // }
    if (progName == "Foundation Studies") {
      returnHTMLtable += '<div class="filterfeecflex">';
      returnHTMLtable += '  <div class="filterbox">';
      returnHTMLtable +=
        '  <label for="foundationprogram">Select program</label>';
      returnHTMLtable +=
        '    <select class="form-select" aria-label="Select the program you are entering" id="foundationprogram">';
      returnHTMLtable += '      <option value="">[SELECT]</option>';
      for (let ii = 0; ii < foundationProgArr.length; ii++) {
        returnHTMLtable +=
          '  <option value="' +
          foundationProgArr[ii].replace(/[^0-9a-z]/gi, "") +
          '">' +
          foundationProgArr[ii] +
          "</option>";
      }
      returnHTMLtable += "    </select>";
      returnHTMLtable += "  </div>";

      returnHTMLtable += "</div>";
      returnHTMLtable += "<div id='foundationtablewrap' style='display:none;'>";
    }
    returnHTMLtable += '<table class="table table-striped aadvtable">';
    // let returnHTMLlist = "";
    returnHTMLtable += "<thead><tr>";
    returnHTMLtable += "<th>Last day to apply</th>";
    returnHTMLtable += "<th>Last day to accept your offer</th>";
    if (progName == "Foundation Studies") {
      returnHTMLtable += "<th>Program</th>";
    }
    if (
      progName == "Foundation English Entry Course (FEEC)" ||
      progName == "University English Entry Course (UEEC)" ||
      progName == "Online University English Entry Course (OUEEC)"
    ) {
      returnHTMLtable += "<th>Entry to / Duration</th>";
    }
    returnHTMLtable += "<th>Orientation</th>";
    returnHTMLtable += "<th>Start of Week One</th>";
    returnHTMLtable += "</tr></thead>";
    returnHTMLtable += "<tbody>";
    for (let index = 0; index < keyDates.length; index++) {
      if (keyDates[index][0] == progName) {
        program = dateArr[0];
        if (
          progName == "Foundation English Entry Course (FEEC)" ||
          progName == "University English Entry Course (UEEC)" ||
          progName == "Online University English Entry Course (OUEEC)"
        ) {
          englishProgramBln = 1;
          orientationdate = keyDates[index][5];
          startdate = keyDates[index][6];
        } else {
          englishProgramBln = 0;
          orientationdate = keyDates[index][8];
          startdate = keyDates[index][9];
        }
        if (orientationdate) {
          dateArr = returnDeadlines(
            auBln,
            orientationdate,
            startdate,
            progName
          );

          let programFilter = keyDates[index][1];
          programFilter = programFilter.replace("Foundation Studies - ", "");
          programFilter = programFilter.replace(
            "Transition Program (on campus)",
            "Transition (on campus)"
          );
          let fsName = "";
          let fsDur = "";

          let studyPath = keyDates[index][4];

          if (progName == "Foundation English Entry Course (FEEC)") {
            let tmpArr = studyPath.split("+");

            fsName = tmpArr[0].replace(/[^0-9a-z]/gi, "");
            fsDur = tmpArr[1].replace(/[^0-9a-z]/gi, "");
            returnHTMLtable +=
              "<tr class='feecrow fsName" + fsName + " fsDur" + fsDur + "'>";
          } else if (
            progName == "University English Entry Course (UEEC)"
          ) {
            let tmpArr = studyPath.split("+");

            fsName = tmpArr[0].replace(/[^0-9a-z]/gi, "");
            fsDur = tmpArr[1].replace(/[^0-9a-z]/gi, "");
            returnHTMLtable +=
              "<tr class='ueecrow fsName" + fsName + " fsDur" + fsDur + "'>";
          } else if (
            progName == "Online University English Entry Course (OUEEC)"
          ) {
            let tmpArr = studyPath.split("+");

            fsName = tmpArr[0].replace(/[^0-9a-z]/gi, "");
            fsDur = tmpArr[1].replace(/[^0-9a-z]/gi, "");
            returnHTMLtable +=
              "<tr class='oueecrow fsName" + fsName + " fsDur" + fsDur + "'>";
          } else if (progName == "Foundation Studies") {
            fsName = programFilter.replace(/[^0-9a-z]/gi, "");
            returnHTMLtable +=
              "<tr class='foundationrow fsName" + fsName + "'>";
          } else {
            returnHTMLtable += "<tr>";
          }

          //CUSTOM OVERRIDES
          if (progName == "Foundation Studies" && programFilter == "Standard Foundation Program" && orientationdate  == "12-Nov-2025") {
            returnHTMLtable += "<td>27-Jul-25</td>";
          } else {
            returnHTMLtable += "<td>" + dateArr[0] + "</td>";
          }

          // Foundation Studies ::programFilter:: Transition (on campus) :orientationdate:2-Jan-25
          // console.log(progName + " :: programFilter :: " + programFilter + " :orientationdate:" + orientationdate);
          if (progName == "Foundation Studies" && programFilter == "Standard Foundation Program" && orientationdate  == "12-Nov-2025") {
             returnHTMLtable += "<td>01-Aug-25</td>";
           } else {
            returnHTMLtable += "<td>" + dateArr[1] + "</td>";
          }
          
          
          if (progName == "Foundation Studies") {
            returnHTMLtable += "<td>" + programFilter + "</td>";
          }
          if (
            progName == "Foundation English Entry Course (FEEC)" ||
            progName == "University English Entry Course (UEEC)" ||
            progName == "Online University English Entry Course (OUEEC)"
          ) {
            returnHTMLtable += "<td>" + studyPath + "</td>";
          }
          returnHTMLtable += "<td>" + orientationdate + "</td>";
          returnHTMLtable += "<td>" + startdate + "</td>";

          returnHTMLtable += "</tr>";
        }
      }
    }
    
    returnHTMLtable += "</tbody>";
    returnHTMLtable += "</table>";

    //CARD

    for (let index = 0; index < keyDates.length; index++) {
      if (keyDates[index][0] == progName) {
        program = dateArr[0];
        if (
          progName == "Foundation English Entry Course (FEEC)" ||
          progName == "University English Entry Course (UEEC)" ||
          progName == "Online University English Entry Course (OUEEC)"
        ) {
          englishProgramBln = 1;
          orientationdate = keyDates[index][5];
          startdate = keyDates[index][6];
        } else {
          englishProgramBln = 0;
          orientationdate = keyDates[index][8];
          startdate = keyDates[index][9];
        }
        if (orientationdate) {
          dateArr = returnDeadlines(
            auBln,
            orientationdate,
            startdate,
            progName
          );

          let programFilter = keyDates[index][1];
          programFilter = programFilter.replace("Foundation Studies - ", "");
          programFilter = programFilter.replace(
            "Transition Program (on campus)",
            "Transition (on campus)"
          );
          let fsName = "";
          let fsDur = "";

          let studyPath = keyDates[index][4];

          if (progName == "Foundation English Entry Course (FEEC)") {
            let tmpArr = studyPath.split("+");

            fsName = tmpArr[0].replace(/[^0-9a-z]/gi, "");
            fsDur = tmpArr[1].replace(/[^0-9a-z]/gi, "");
            returnHTMLtable +=
              '<div class="card aadvcard feecrow fsName' +
              fsName +
              " fsDur" +
              fsDur +
              '"><div class="card-body">';
          } else if (progName == "University English Entry Course (UEEC)") {
            let tmpArr = studyPath.split("+");

            fsName = tmpArr[0].replace(/[^0-9a-z]/gi, "");
            fsDur = tmpArr[1].replace(/[^0-9a-z]/gi, "");
            returnHTMLtable +=
              '<div class="card aadvcard ueecrow fsName' +
              fsName +
              " fsDur" +
              fsDur +
              '"><div class="card-body">';
          } else if (progName == "Online University English Entry Course (OUEEC)") {
            let tmpArr = studyPath.split("+");

            fsName = tmpArr[0].replace(/[^0-9a-z]/gi, "");
            fsDur = tmpArr[1].replace(/[^0-9a-z]/gi, "");
            returnHTMLtable +=
              '<div class="card aadvcard oueecrow fsName' +
              fsName +
              " fsDur" +
              fsDur +
              '"><div class="card-body">';
          } else if (progName == "Foundation Studies") {
            fsName = programFilter.replace(/[^0-9a-z]/gi, "");
            returnHTMLtable +=
              '<div class="card aadvcard foundationrow fsName' +
              fsName +
              '"><div class="card-body">';
          } else {
            returnHTMLtable +=
              '<div class="card aadvcard"><div class="card-body">';
          }
          returnHTMLtable +=
            '<div class="dtrow"><div class="lbl">Last day to apply</div><div class="val">' +
            dateArr[0] +
            "</div></div>";

          returnHTMLtable +=
            '<div class="dtrow"><div class="lbl">Last day to accept your offer</div><div class="val">' +
            dateArr[1] +
            "</div></div>";

          if (progName == "Foundation Studies") {
            returnHTMLtable +=
              '<div class="dtrow"><div class="lbl">Program</div><div class="val">' +
              programFilter +
              "</div></div>";
          }
          if (
            progName == "Foundation English Entry Course (FEEC)" ||
            progName == "University English Entry Course (UEEC)" ||
            progName == "Online University English Entry Course (OUEEC)"
          ) {
            returnHTMLtable +=
              '<div class="dtrow"><div class="lbl">Entry to / Duration</div><div class="val">' +
              studyPath +
              "</div></div>";
          }
          returnHTMLtable +=
            '<div class="dtrow"><div class="lbl">Orientation</div><div class="val">' +
            orientationdate +
            "</div></div>";
          returnHTMLtable +=
            '<div class="dtrow"><div class="lbl">Start of Week One</div><div class="val">' +
            startdate +
            "</div></div>";


          returnHTMLtable += "</div></div>";
        }
      }
    }

    //END CARD
    // if (progName == "University English Entry Course (UEEC)") {
    //   returnHTMLtable += '* For Stand-alone offers, the last day to apply is Wednesday 10th of July 2024 and the last day to accept is Friday, 19th of July 2024';
    // }
    



    const fsprograms = [
      { prgcode: "tp", name: "Transition Program", url: "https://www.unswcollege.edu.au/study/transition-program?utm_source=aad&utm_medium=web&utm_campaign=aadreturnlinks&utm_id=aad" },
      { prgcode: "sp", name: "Standard Program", url: "https://www.unswcollege.edu.au/study/standard-program?utm_source=aad&utm_medium=web&utm_campaign=aadreturnlinks&utm_id=aad" },
      { prgcode: "spp", name: "Standard Plus Program", url: "https://www.unswcollege.edu.au/study/standard-plus-program?utm_source=aad&utm_medium=web&utm_campaign=aadreturnlinks&utm_id=aad" },
    ];


    
    let ctaApplyBttnLinksHtml = '<a href="https://www.unswcollege.edu.au/apply/apply-now?utm_source=aad&utm_medium=web&utm_campaign=aadreturnlinks&utm_id=aad" target="_top" class="unswccta"><span class="txt">Apply now</span><span class="ico"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 500"><path d="M61.05 472.91c-9.09 0-18.17-3.47-25.1-10.4-13.86-13.86-13.86-36.34 0-50.21l162.31-162.31L35.94 87.69c-13.86-13.86-13.86-36.34 0-50.2s36.34-13.86 50.21 0L273.56 224.9c13.86 13.86 13.86 36.34 0 50.2L86.15 462.51c-6.93 6.93-16.02 10.4-25.1 10.4Z"/></svg></span></a><a href="https://www.unswcollege.edu.au/study/key-dates?utm_source=aad&utm_medium=web&utm_campaign=aadreturnlinks&utm_id=aad" target="_top" class="unswccta white"><span class="txt">Key dates</span><span class="ico"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 500"><path d="M61.05 472.91c-9.09 0-18.17-3.47-25.1-10.4-13.86-13.86-13.86-36.34 0-50.21l162.31-162.31L35.94 87.69c-13.86-13.86-13.86-36.34 0-50.2s36.34-13.86 50.21 0L273.56 224.9c13.86 13.86 13.86 36.34 0 50.2L86.15 462.51c-6.93 6.93-16.02 10.4-25.1 10.4Z"/></svg></span></a>';
    let ctaBttnsHtml = "";
    switch(progName) {
      case "Diplomas":
        ctaBttnsHtml += '<div class="learnmorecols"><div class="leftcol"><h4>Study with us</h4>';
        ctaBttnsHtml += '<ul class="proglinks">';
        ctaBttnsHtml += '<li ><a href="https://www.unswcollege.edu.au/study/diplomas-overview?utm_source=aad&utm_medium=web&utm_campaign=aadreturnlinks&utm_id=aad" target="_top">International Diplomas</a></li>';
        ctaBttnsHtml += '<li ><a href="https://www.unswcollege.edu.au/study/domestic-diplomas?utm_source=aad&utm_medium=web&utm_campaign=aadreturnlinks&utm_id=aad" target="_top">Domestic Diplomas</a></li>';
        ctaBttnsHtml += '</ul></div><div class="rightcol">'+ctaApplyBttnLinksHtml+'</div></div>';
        break;
      case "Foundation Studies":
        ctaBttnsHtml += '<div class="learnmorecols"><div class="leftcol"><h4>Study with us</h4>';
        ctaBttnsHtml += '<ul class="proglinks">';
        fsprograms.forEach(fsprogram => {
            ctaBttnsHtml += '<li class="fsprgcode fsprgcode'+fsprogram.prgcode+'"><a href="'+fsprogram.url+'" target="_top">'+fsprogram.name+'</a></li>';
        });
        ctaBttnsHtml += '</ul></div><div class="rightcol">'+ctaApplyBttnLinksHtml+'</div></div>';
        break;
      case "Foundation English Entry Course (FEEC)":
        ctaBttnsHtml += '<div class="learnmorecols"><div class="leftcol"><h4>Study with us</h4>';
        ctaBttnsHtml += '<ul class="proglinks">';
        ctaBttnsHtml += '<li ><a href="https://www.unswcollege.edu.au/study/foundation-english-entry-course?utm_source=aad&utm_medium=web&utm_campaign=aadreturnlinks&utm_id=aad" target="_top">Foundation English Entry Course (FEEC)</a></li>';
        ctaBttnsHtml += '</ul></div><div class="rightcol">'+ctaApplyBttnLinksHtml+'</div></div>';
        break;
      case "University English Entry Course (UEEC)":
        ctaBttnsHtml += '<div class="learnmorecols"><div class="leftcol"><h4>Study with us</h4>';
        ctaBttnsHtml += '<ul class="proglinks">';
        ctaBttnsHtml += '<li ><a href="https://www.unswcollege.edu.au/study/university-english-entry-course?utm_source=aad&utm_medium=web&utm_campaign=aadreturnlinks&utm_id=aad" target="_top">University English Entry Course (UEEC)</a></li>';
        ctaBttnsHtml += '</ul></div><div class="rightcol">'+ctaApplyBttnLinksHtml+'</div></div>';
        break;
      case "Online University English Entry Course (OUEEC)":
        ctaBttnsHtml += '<div class="learnmorecols"><div class="leftcol"><h4>Study with us</h4>';
        ctaBttnsHtml += '<ul class="proglinks">';
        ctaBttnsHtml += '<li ><a href="https://www.unswcollege.edu.au/study/online-university-english-entry-course?utm_source=aad&utm_medium=web&utm_campaign=aadreturnlinks&utm_id=aad" target="_top">Online University English Entry Course (OUEEC)</a></li>';
        ctaBttnsHtml += '</ul></div><div class="rightcol">'+ctaApplyBttnLinksHtml+'</div></div>';
        break;
      case "Tertiary Orientation Program (TOP) (5 weeks)":
        ctaBttnsHtml += '<div class="learnmorecols"><div class="leftcol"><h4>Study with us</h4>';
        ctaBttnsHtml += '<ul class="proglinks">';
        ctaBttnsHtml += '<li ><a href="https://www.unswcollege.edu.au/study/tertiary-orientation-program?utm_source=aad&utm_medium=web&utm_campaign=aadreturnlinks&utm_id=aad" target="_top">Tertiary Orientation Program</a></li>';
        ctaBttnsHtml += '</ul></div><div class="rightcol">'+ctaApplyBttnLinksHtml+'</div></div>';
        break;
      case "Pre-Masters":
        ctaBttnsHtml += '<div class="learnmorecols"><div class="leftcol"><h4>Study with us</h4>';
        ctaBttnsHtml += '<ul class="proglinks">';
        ctaBttnsHtml += '<li ><a href="https://www.unswcollege.edu.au/study/pre-masters-overview?utm_source=aad&utm_medium=web&utm_campaign=aadreturnlinks&utm_id=aad" target="_top">Pre-Masters Program</a></li>';
        ctaBttnsHtml += '</ul></div><div class="rightcol">'+ctaApplyBttnLinksHtml+'</div></div>';
        
        break;
      default:
        // code block
    }

    returnHTMLtable += '<div class="learnmorelinks">'+ctaBttnsHtml+'</div>';
    returnHTMLtable += '</div>';


    if (
      progName == "Foundation English Entry Course (FEEC)" ||
      progName == "University English Entry Course (UEEC)" ||
      progName == "Online University English Entry Course (OUEEC)" ||
      progName == "Foundation Studies"
    ) {
      //closes table wrapper
      returnHTMLtable += "</div>";
    }
    returnHTML = returnHTMLtable;
    return returnHTML;
  };
  //populate outputStep - program selection
  const populateProgramNames = (keyDates) => {
    console.log("populateProgramNames");

    //reset program selections
    aadvProgramBoxOptions.innerHTML = "";
    console.log("programsArr");
    console.log(programsArr);
    let progBoxHtml = "";
    let progDatesHtml = "";
    let auBln = aadvCountry.value == "Australia" ? true : false;
    for (let index = 0; index < programsArr.length; index++) {
      let progName = programsArr[index].programName;
      let progNameCode = progName.replace(/[^0-9a-z]/gi, "");
      var skipOUEEC = progNameCode === "OnlineUniversityEnglishEntryCourseOUEEC" && auBln;
      if (!skipOUEEC) {
        progBoxHtml +=
          '<div class="aadvProgramBoxOption progbox' + progNameCode + '" data-prog="' + progNameCode + '">' +
            '<div class="txt"><h2>' + progName + '</h2></div>' +
            '<div class="aadvcircle-plus aadvclosed" data-progcode="' + progNameCode + '">' +
              '<div class="aadvcircle">' +
                '<div class="aadvhorizontal"></div>' +
                '<div class="aadvvertical"></div>' +
              '</div>' +
            '</div>' +
          '</div>';
      }
      
      // console.log(progBoxHtml);

      progDatesHtml = getProgDates(progName);
      progBoxHtml += progDatesHtml;
    }
    aadvProgramBoxOptions.innerHTML = progBoxHtml;

    let feecentryto = document.getElementById("feecentryto");
    feecentryto.addEventListener("change", function () {
      doFeecResults();
    });

    let feecduration = document.getElementById("feecduration");
    feecduration.addEventListener("change", function () {
      doFeecResults();
    });

    let ueecentryto = document.getElementById("ueecentryto");
    ueecentryto.addEventListener("change", function () {
      doUeecResults();
    });

    let ueecduration = document.getElementById("ueecduration");
    ueecduration.addEventListener("change", function () {
      doUeecResults();
    });

    // let oueecentryto = document.getElementById("oueecentryto");
    // oueecentryto.addEventListener("change", function () {
    //   doOUeecResults();
    // });

    // let oueecduration = document.getElementById("oueecduration");
    // oueecduration.addEventListener("change", function () {
    //   doOUeecResults();
    // });

    let foundationprogram = document.getElementById("foundationprogram");
    foundationprogram.addEventListener("change", function () {
      doFoundationResults();
    });
  };
  const doFoundationResults = () => {
    let foundationprogram = document.getElementById("foundationprogram").value;
    console.log("FSProg:" + foundationprogram);
    let foundationtablewrap = document.getElementById("foundationtablewrap");
    if (foundationprogram) {
      foundationtablewrap.style.display = "block";
      var tableRows = document.getElementsByClassName("foundationrow");
      for (var i = 0; i < tableRows.length; i++) {
        if (tableRows[i].classList.contains("fsName" + foundationprogram)) {
          tableRows[i].style.display = "";
        } else {
          tableRows[i].style.display = "none";
        }
      }
    } else {
      foundationtablewrap.style.display = "none";
    }
    // Hide all foundation program links
    const fsProgLinks = document.getElementsByClassName('fsprgcode');
    for (let i = 0; i < fsProgLinks.length; i++) {
      fsProgLinks[i].style.display = 'none';
    }

    // Map foundation program values to their corresponding class names
    const programClassMap = {
      "TransitionProgram": "fsprgcodetp",
      "StandardPlusFoundationProgram": "fsprgcodespp",
      "StandardFoundationProgram": "fsprgcodesp"
    };

    // Show only the relevant program links
    const classToShow = programClassMap[foundationprogram];
    if (classToShow) {
      const elementsToShow = document.getElementsByClassName(classToShow);
      for (let i = 0; i < elementsToShow.length; i++) {
        elementsToShow[i].style.display = 'block';
      }
    }

    
  };
  const doUeecResults = () => {
    let ueecentryto = document.getElementById("ueecentryto").value;
    let ueecduration = document.getElementById("ueecduration").value;
    console.log("ueecentryto:" + ueecentryto + " ueecduration:" + ueecduration);
    if (ueecentryto == "Degree") {
      var notdegreeItems = document.getElementsByClassName('notdegree');
      for (var i = 0; i < notdegreeItems.length; i ++) {
        notdegreeItems[i].style.display = 'none';
      }
      var degreeItems = document.getElementsByClassName('degreeonly');
      for (var i = 0; i < degreeItems.length; i ++) {
        degreeItems[i].style.display = 'block';
      }

    } else {
      var notdegreeItems = document.getElementsByClassName('notdegree');
      for (var i = 0; i < notdegreeItems.length; i ++) {
        notdegreeItems[i].style.display = 'block';
      }
      var degreeItems = document.getElementsByClassName('degreeonly');
      for (var i = 0; i < degreeItems.length; i ++) {
        degreeItems[i].style.display = 'none';
      }
    }
    let ueectablewrap = document.getElementById("ueectablewrap");
    if (ueecduration && ueecentryto) {
      ueectablewrap.style.display = "block";
      var tableRows = document.getElementsByClassName("ueecrow");
      for (var i = 0; i < tableRows.length; i++) {
        if (
          tableRows[i].classList.contains("fsName" + ueecentryto) &&
          tableRows[i].classList.contains("fsDur" + ueecduration)
        ) {
          tableRows[i].style.display = "";
        } else {
          tableRows[i].style.display = "none";
        }
      }
    } else {
      ueectablewrap.style.display = "none";
    }
  };
  // const doOUeecResults = () => {
  //   let oueecentryto = document.getElementById("oueecentryto").value;
  //   let oueecduration = document.getElementById("oueecduration").value;
  //   console.log("oueecentryto:" + oueecentryto + " oueecduration:" + oueecduration);
  //   if (oueecentryto == "Degree") {
  //     var notdegreeItems = document.getElementsByClassName('notdegree');
  //     for (var i = 0; i < notdegreeItems.length; i ++) {
  //       notdegreeItems[i].style.display = 'none';
  //     }
  //     var degreeItems = document.getElementsByClassName('degreeonly');
  //     for (var i = 0; i < degreeItems.length; i ++) {
  //       degreeItems[i].style.display = 'block';
  //     }

  //   } else {
  //     var notdegreeItems = document.getElementsByClassName('notdegree');
  //     for (var i = 0; i < notdegreeItems.length; i ++) {
  //       notdegreeItems[i].style.display = 'block';
  //     }
  //     var degreeItems = document.getElementsByClassName('degreeonly');
  //     for (var i = 0; i < degreeItems.length; i ++) {
  //       degreeItems[i].style.display = 'none';
  //     }
  //   }
  //   let oueectablewrap = document.getElementById("oueectablewrap");
  //   if (oueecduration && oueecentryto) {
  //     oueectablewrap.style.display = "block";
  //     var tableRows = document.getElementsByClassName("oueecrow");
  //     for (var i = 0; i < tableRows.length; i++) {
  //       if (
  //         tableRows[i].classList.contains("fsName" + oueecentryto) &&
  //         tableRows[i].classList.contains("fsDur" + oueecduration)
  //       ) {
  //         tableRows[i].style.display = "";
  //       } else {
  //         tableRows[i].style.display = "none";
  //       }
  //     }
  //   } else {
  //     oueectablewrap.style.display = "none";
  //   }
  // };
  const doFeecResults = () => {
    let feecentryto = document.getElementById("feecentryto").value;
    let feecduration = document.getElementById("feecduration").value;
    console.log(feecduration + "---" + feecentryto);
    let feectablewrap = document.getElementById("feectablewrap");
    if (feecduration && feecentryto) {
      feectablewrap.style.display = "block";
      var tableRows = document.getElementsByClassName("feecrow");
      for (var i = 0; i < tableRows.length; i++) {
        if (
          tableRows[i].classList.contains("fsName" + feecentryto) &&
          tableRows[i].classList.contains("fsDur" + feecduration)
        ) {
          tableRows[i].style.display = "";
        } else {
          tableRows[i].style.display = "none";
        }
      }
    } else {
      feectablewrap.style.display = "none";
    }
  };

  const outputStep = () => {
    console.log("outputStep");
    //are we gs?
    //let countrygs = gsCountryArr.includes(aadvCountry.value);

    populateProgramNames();
    watchAccordion();

  };
});
